var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('progress-loading',{attrs:{"can-cancel":false,"is-full-page":true,"progress":_vm.progress,"message":_vm.message,"message-bottom":_vm.messageBottom},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }